import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import { Link, Element, Events, animateScroll as scroll, scroller } from "react-scroll";
import Hero from './components/Hero';
import FloatingNavbar from './ui/FloatingNavbar';
import { SparklesCore } from './ui/Sparkles';
import { navItems } from './data/index';
import Grid from './components/Grid';
import { useState, useRef } from 'react';
import RecentProjects from './components/RecentProjects';
import Clients from './components/Clients';
import Experience from './components/Experience';
import Approach from './components/Approach';
import Contact from './components/Contact';

function App() {
  

  const [show2, setShow2] = useState(false);
const [lastScrollY, setLastScrollY] = useState(0); // To store the last scroll position

const handleScroll = (e) => {
    const currentScrollY = e.target.scrollTop; // Get scroll position from the div

    if (currentScrollY > lastScrollY) {
        // Scrolling down
        setShow2(true);
    } else {
        // Scrolling up
        setShow2(false);
    }

    setLastScrollY(currentScrollY); // Update the last scroll position
};

// Function to scroll to a specific element using react-scroll

const contactRef = useRef(null);
const aboutRef = useRef(null);
const testimonialsRef = useRef(null);
const projectRef = useRef(null);
// Custom smooth scroll function in React
const scrollToElementa = (targetRef) => {
  if (!targetRef.current) return;
    console.log("we scrolin to", targetRef)
    targetRef.current.scrollIntoView({behaviour: "smooth"})
  
};

const scrollToElement = (elId) => {
  if(elId === "contact"){
    scrollToElementa(contactRef)
  }else if(elId === "about"){
    scrollToElementa(aboutRef)
  }else if(elId === "testimonials"){
    scrollToElementa(testimonialsRef)
  }else{
    scrollToElementa(projectRef)
  }
}


  return (
  <Router>
    <div className="App" onScroll={handleScroll} >      
          <FloatingNavbar navItems={navItems} show2={show2} scrollToElement={scrollToElement} /> 
                <Hero scrollToElement={scrollToElement} /> 
              <Grid aboutRef={aboutRef} />
              <Approach/>
              <Experience/>
              <RecentProjects projectRef={projectRef} />
              <Clients testimonialsRef={testimonialsRef} />    
              <Contact contactRef={contactRef} /> 
    </div>
  </Router> 
  );
}

export default App;
